// import stripe from 'stripe';
// const stripe = require('@stripe/stripe-js')('sk_test_ko1Hp1CX04FKgXaIS0apbeGj00shEk58oU');
import { Elements } from '@stripe/react-stripe-js';
import ClassCheckout from 'components/ClassCheckout';
import ClassConfirmation from 'components/ClassConfirmation';
import ClassList from 'components/ClassList';
import React from "react";
import { useLocation } from "react-router-dom";
// import AsyncStripeProvider from 'util/AsyncStripeProvider';
import { StripeProvider } from 'react-stripe-elements';
import { Route, Switch, useRouter } from "util/router.js";
import ClassWidget from 'pages/classWidget'
import PricingWidget from 'pages/PricingWidget'
import OnDemandWidget from 'components/OnDemandWidget'
import GiftCardCheckout from 'pages/giftCardCheckout'
import WriteReview from 'pages/writeReview'
// import "./classWidget.scss";

// / A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function PartnerWidget(props) {
    const { match, stripe, widgetName } = props;
    return (
    <>
        <Switch>
            {/* <Route 
                path={`${match.url}/buy`}
                render={props => {
                    return  (<>
                        buy
                    </>)
                }} 
            /> */}
            <Route
                path={`${match.url}/write-review`} 
                render={props => {
                    return (<>
                        <WriteReview {...props}/>
                    </>)
                }}
            />
            <Route
                path={`${match.url}/gifting`} 
                render={props => {
                    
                    return (<>
                    <StripeProvider stripe={stripe} >
                        <Elements stripe={stripe} >
                            <GiftCardCheckout {...props}/>
                        </Elements>
                    </StripeProvider>
                    </>)
                }}
            />
            <Route 
                path={`${match.url}/on-demand`}
                render={props => {
                    return  (<>
                        <OnDemandWidget stripe={stripe} {...props} />
                    </>)
                }} 
            />
            <Route
                path={`${match.url}/pricing`} 
                render={props => {
                    
                    return (<>
                        <PricingWidget stripe={stripe} {...props} />
                    </>)
                }}
            />
            <Route
                path={`${match.url}`}
                render={props => {
                    return (<>
                        <ClassWidget stripe={stripe} {...props}/>
                    </>)
                }}>
                
            </Route>
        </Switch>
    </>
    )
}

export default PartnerWidget;